import styles from './StarRating.module.css';

function StarRating({ rating, reviewCount, size = 'medium' }) {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className={styles.ratingContainer}>
      <div className={styles.stars}>
        {[...Array(fullStars)].map((_, i) => (
          <span key={`full-${i}`} className={`${styles.star} ${styles.full}`}>
            ★
          </span>
        ))}
        {hasHalfStar && <span className={`${styles.star} ${styles.half}`}>★</span>}
        {[...Array(emptyStars)].map((_, i) => (
          <span key={`empty-${i}`} className={`${styles.star} ${styles.empty}`}>
            ★
          </span>
        ))}
      </div>
      {reviewCount !== undefined && (
        <span className={styles.reviewCount}>({reviewCount})</span>
      )}
    </div>
  );
}

export default StarRating;

